var irreducible = require('./irreducible');
var isBoolean = require('./isBoolean');

module.exports = irreducible('Boolean', isBoolean);



// WEBPACK FOOTER //
// ./node_modules/tcomb/lib/Boolean.js